<template>
  <form class="page-color-picker-hsl" @submit.prevent="confirmColor">
    <Chrome class="picker" v-model="color" v-if="color" :disableFields="true" />
    <HMModalFooter
      :submitButton="$t('GENERAL.BUTTON.SELECT')"
      @close="onDiscard"
    />
  </form>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: 'PageColorPickerHSL',
  components: {
    Chrome,
  },
  props: {
    inputColor: {
      type: String,
      default: '#000000',
    },
  },
  data() {
    return {
      color: undefined,
    };
  },
  methods: {
    getActiveColor() {
      const rgba = this.color?.rgba;
      return `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`;
    },
    confirmColor() {
      const color = this.getActiveColor();
      this.$parent.$emit('color-selected', color);
      this.$emit('close');
    },
    onDiscard() {
      this.$emit('close');
    },
  },
  mounted() {
    console.log(this.inputColor);
    this.color = this.inputColor || '#000000';
  },
};
</script>

<style lang="scss" scoped>
.picker {
  box-shadow: none;
  width: 100%;
}
</style>
